import type { PlotItem } from "@/types/film";

export const plotList: PlotItem[] = [
  {
    id: "p1",
    chapter: "第一章",
    title: "蜜桃园的第一个夏天",
    act: "第一幕 · 初遇",
    summary:
      "十六岁的苏蜜在自家蜜桃园里遇见前来帮工的青年江樾。一个夏天，两段截然不同的成长轨迹悄然靠近。",
    content:
      "故事从蜜桃园的盛夏开始。苏蜜出生在这片果园，她的童年记忆里，桃子的甜香与蝉鸣始终缠绕在一起。这一年夏天，果园来了一个城里来的帮工——江樾。\n\n江樾沉默寡言，却对果树有一种近乎执拗的耐心。他会在天没亮的时候起来查看果实的成色，也会在傍晚坐在树下，把一天的光影画进速写本。苏蜜起初觉得他古怪，后来却渐渐习惯了他的存在。\n\n整个夏天，两人一起守着这片果园，也一起度过了各自的迷茫。苏蜜第一次意识到，原来「成熟」这件事，对果实和对人来说，都不是一蹴而就的。",
    image:
      "https://readdy.ai/api/search-image?query=warm%20sunlit%20peach%20orchard%20with%20ripening%20fruit%20on%20branches%20and%20soft%20morning%20light%2C%20cinematic%20film%20still%2C%20cozy%20dramatic%20mood%2C%20warm%20peach%20tones%2C%20high%20detail&width=800&height=600&seq=peach-plot-01&orientation=landscape",
  },
  {
    id: "p2",
    chapter: "第二章",
    title: "离别的站台",
    act: "第一幕 · 初遇",
    summary:
      "秋天来临，江樾决定回到城市继续未完成的学业。小镇的站台上，苏蜜没能说出口的话，成了往后许多年的心结。",
    content:
      "夏天结束得比想象中更快。江樾收到了一封来自城市的信，那是他等待已久的返校通知。离开的前一晚，两人坐在果园里，谁都没有先开口。\n\n第二天清晨，苏蜜送他去镇上的站台。火车进站时，江樾把速写本留给了她，说：「这里面有整个夏天。」苏蜜接过本子，却终究没有说出那句在心里练习了无数遍的话。\n\n火车开走后，站台恢复了往日的安静。苏蜜独自走回果园，翻开速写本，最后一页画的是她站在树下的背影，旁边写着一行小字：「明年，桃子该熟了吧。」",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20countryside%20train%20platform%20at%20golden%20hour%20with%20soft%20warm%20light%20and%20empty%20tracks%2C%20cinematic%20film%20still%2C%20amber%20color%20grade%2C%20atmospheric%20and%20melancholic%2C%20high%20detail&width=800&height=600&seq=peach-plot-02&orientation=landscape",
  },
  {
    id: "p3",
    chapter: "第三章",
    title: "城市里的重逢",
    act: "第二幕 · 重逢",
    summary:
      "多年后，苏蜜为寻找新的果园经营思路来到城市，在一场行业分享会上与江樾意外重逢。",
    content:
      "时光流转，苏蜜已经接手了家里的果园。为了让父辈留下的这片土地走得更远，她第一次来到城市，参加一场关于农业与设计的分享会。\n\n在会场的角落里，她看到了一个熟悉的身影。江樾已经成为一名小有名气的视觉设计师，正在讲述如何用影像记录土地的变化。当他在大屏幕上放出一张蜜桃园的照片时，台下的苏蜜愣住了——那正是她家的果园。\n\n分享会结束后，两人在会场外相遇。多年的时间仿佛被压缩成一句话的长度。江樾先笑了：「我一直在等桃子成熟。」苏蜜低头，不知道该说什么。",
    image:
      "https://readdy.ai/api/search-image?query=modern%20bright%20exhibition%20hall%20with%20warm%20ambient%20lighting%20and%20soft%20golden%20accents%2C%20cinematic%20film%20still%2C%20warm%20peach%20color%20grade%2C%20elegant%20atmospheric%20mood%2C%20high%20detail&width=800&height=600&seq=peach-plot-03&orientation=landscape",
  },
  {
    id: "p4",
    chapter: "第四章",
    title: "雨夜的抉择",
    act: "第二幕 · 重逢",
    summary:
      "家乡传来果园面临转变的消息，苏蜜必须在理想与现实之间做出选择。那场雨夜，两人第一次把话说开。",
    content:
      "重逢并没有立刻带来和解。苏蜜得知，家乡的果园正面临被转让的可能，父辈留下的土地或许将不再属于他们。她必须在继续坚守与接受现实之间做出选择。\n\n那个夜晚下起了大雨。江樾找到独自坐在屋檐下的苏蜜，两人终于把多年来积压的话一一说开。苏蜜说，她害怕自己守不住这片果园，也守不住记忆里的那个夏天。江樾却说，果园从来不是被守住的，而是被记住的。\n\n雨停时天边泛白。苏蜜做出决定：回小镇，用自己的方式，让果园继续生长下去。这一次，江樾选择和她一起回去。",
    image:
      "https://readdy.ai/api/search-image?query=rainy%20evening%20under%20a%20wooden%20eaves%20with%20warm%20reflected%20light%20on%20wet%20ground%2C%20cinematic%20film%20still%2C%20amber%20and%20orange%20glow%2C%20atmospheric%20and%20emotional%2C%20high%20detail&width=800&height=600&seq=peach-plot-04&orientation=landscape",
  },
  {
    id: "p5",
    chapter: "第五章",
    title: "屋顶上的约定",
    act: "第三幕 · 成熟",
    summary:
      "回到小镇的两人开始重新打理果园。一个晴朗的夜晚，他们在屋顶上约定，要把这里的故事讲给更多人听。",
    content:
      "回到小镇后，苏蜜和江樾一起重新规划果园。江樾用他的设计经验，为果园设计了新的标识与体验路线；苏蜜则坚持保留每一棵老树，尤其是那些陪伴她长大的植株。\n\n忙碌之余，两人常在傍晚爬上老屋的屋顶。那里可以看到整片果园，也能看到远处的海岸线。一个晴朗的夜晚，江樾拿出一张新的速写——这一次，画的是一整片在灯下生长的果树。\n\n他们在屋顶上约定，要把这片土地的故事记录下来，讲给更多的人听。苏蜜说，也许有一天，会有人因为这些故事，愿意来尝一口真正的蜜桃。",
    image:
      "https://readdy.ai/api/search-image?query=cozy%20rooftop%20at%20dusk%20with%20warm%20string%20lights%20and%20soft%20glowing%20bokeh%2C%20cinematic%20film%20still%2C%20romantic%20warm%20palette%2C%20atmospheric%20and%20tender%20mood%2C%20high%20detail&width=800&height=600&seq=peach-plot-05&orientation=landscape",
  },
  {
    id: "p6",
    chapter: "终章",
    title: "成熟时",
    act: "第三幕 · 成熟",
    summary:
      "又一个夏天到来，果园迎来了丰收。苏蜜终于明白，真正的成熟，是学会与过去和解，并继续向前走。",
    content:
      "又一个夏天。果园里的蜜桃挂满了枝头，阳光穿过枝叶，落在地上形成斑驳的光影。这一年的收成格外好，小镇也因为有越来越多的人前来，变得热闹起来。\n\n在丰收的那一天，苏蜜站在果园中央，想起许多年前那个沉默的少年和他留下的速写本。她终于明白，所谓成熟，并不是遗忘，而是带着过去继续往前走。\n\n傍晚，江樾递给她一颗刚摘下的蜜桃，问她：「这一次，尝出味道了吗？」苏蜜咬了一口，笑了。她说：「尝出来了，是夏天的味道。」两人的身影在夕阳下被拉得很长，风吹过果园，带着熟悉的甜香。",
    image:
      "https://readdy.ai/api/search-image?query=cinematic%20view%20through%20a%20sunlit%20peach%20orchard%20at%20golden%20hour%20with%20dappled%20warm%20light%20and%20abundant%20fruit%2C%20emotional%20film%20still%2C%20warm%20amber%20haze%2C%20atmospheric%2C%20high%20detail&width=800&height=600&seq=peach-plot-06&orientation=landscape",
  },
];